<script lang="ts" setup generic="T extends { [key: string]: unknown }">
import { useQuery } from "@tanstack/vue-query";
import { v4 } from "uuid";
import { computed, ref } from "vue";

import { IDataTableDropdownOption } from "@/data/api/kili/common/datatable/data-table-definition";

import AutoCompleteCustom from "@/components/ui/inputs/autocomplete/autocomplete-custom.vue";

interface Props {
  options?:
    | Array<IDataTableDropdownOption>
    | (() => Array<IDataTableDropdownOption>)
    | (() => Promise<Array<IDataTableDropdownOption>>);
  filterOn: keyof IDataTableDropdownOption;
  placeholder?: string;
}

const props = defineProps<Props>();

const model = defineModel<T>();

const queryUuid = ref(v4());

const { data: options, isLoading } = useQuery({
  queryKey: [queryUuid],
  queryFn: async () => {
    if (props.options === undefined) {
      return [];
    }

    if (typeof props.options === "function") {
      return await props.options();
    }

    return props.options;
  },
});

const value = computed<IDataTableDropdownOption | undefined>({
  get: () => {
    return options.value?.find((a) => a.value === model.value);
  },
  set: (value: IDataTableDropdownOption | undefined) => {
    if (!value) {
      model.value = undefined;
    } else if (value.value) {
      model.value = value.value;
    }
  },
});
</script>

<template>
  <div
    v-if="isLoading"
    class="self-end h-full mb-[4px]"
  >
    <Skeleton
      height="43px"
      width="10rem"
    />
  </div>
  <AutoCompleteCustom
    v-else
    v-model="value"
    clearable
    dropdown
    :filter-on="$props.filterOn"
    float-label
    :items="options"
    :placeholder="props.placeholder"
  />
</template>
